<template>
  <div>
    <div class="tw-flex tw-justify-center tw-items-center">
      <button class="base-btn tw-py-1 tw-px-2" @click.stop="openForm">
        <i class="fas fa-edit"> </i>
      </button>
    </div>

    <v-dialog v-model="dialog" persistent :width="width" :max-width="maxWidth">
      <div
        class="tw-bg-white tw-justify-center tw-flex tw-p-5 tw-rounded-xl tw-min-h-[250px]"
      >
        <ValidationObserver
          class="tw-flex tw-flex-col tw-w-full"
          ref="appForm"
          @submit.prevent="submit"
        >
          <div
            class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3 tw-mb-3"
          >
            <template v-for="(data, index) in formData">
              <div
                :key="index"
                :class="data.fullWidth ? 'md:tw-col-span-2' : ''"
              >
                <component
                  :is="data.inputType"
                  :name="data.name"
                  v-model="data.modelValue"
                  :placeholder="data.placeholder"
                  :label="data.label"
                  :rules="data.rules"
                  :data="data"
                  :modalName="data.modalName"
                  :api-url="data.apiUrl"
                  @imageDeleted="imageDeleted(index)"
                ></component>
              </div>
            </template>
            <slot />
          </div>

          <div
            class="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-mt-auto"
          >
            <button
              type="submit"
              @click="submit"
              class="base-btn tw-py-1"
              :disabled="btnLoading"
            >
              {{ $t(`BUTTONS.edit`) }}
            </button>
            <button
              class="base-btn-white tw-py-1"
              @click="close"
              :disabled="btnLoading"
            >
              {{ $t("BUTTONS.close") }}
            </button>
          </div>
          <!-- <app-input name="title" v-model="title" /> -->
        </ValidationObserver>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      required: true,
    },
    classes: {
      required: false,
    },
    width: {
      required: false,
    },
    maxWidth: {
      required: false,
    },
    id: {
      required: true,
    },
    url: {
      required: true,
    },
    loading: {
      required: false,
    },
    closeModal: {
      required: false,
    },
    btnName: {
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
      form_fields: [],
      btnLoading: false,
    };
  },
  methods: {
    submit() {
      this.$refs.appForm.validate().then((valid) => {
        if (valid) this.$emit("submit", this.form_fields);
      });
    },
    imageDeleted(index) {
      this.$emit("imageDeleted", index);
    },
    close() {
      this.$refs.appForm.reset();
      this.dialog = false;
    },
    openForm() {
      this.axios({
        method: "GET",
        url: `${this.url}/${this.id}`,
      })
        .then((res) => {
          const result = res.data.data;

          this.formData.map((el) => {
            if (el.key == "[ar][question]") {
              el.modelValue = result.question_ar;
            } else if (el.key == "[en][question]") {
              el.modelValue = result.question_en;
            } else if (el.key == "[ar][answer]") {
              el.modelValue = result.answer_ar;
            } else if (el.key == "[en][answer]") {
              el.modelValue = result.answer_en;
            }
            this.form_fields.push(el);
          });

          this.dialog = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // finalSubmit() {
    //   this.btnLoading = true;
    //   const submit_data = new FormData();
    //   this.formData.map((el) => {
    //     if (el.key == "[ar][question]") {
    //       submit_data.append(`ar[question]`, el.modelValue);
    //     } else if (el.key == "[en][question]") {
    //       submit_data.append(`en[question]`, el.modelValue);
    //     } else if (el.key == "[ar][answer]") {
    //       submit_data.append(`ar[answer]`, el.modelValue);
    //     } else if (el.key == "[en][answer]") {
    //       submit_data.append(`en[answer]`, el.modelValue);
    //     }
    //   });
    //   submit_data.append(`service_id`, this.$route.params.id);

    //   submit_data.append(`_method`, "PUT");

    //   this.axios({
    //     method: "POST",
    //     url: `${this.url}/${this.id}`,
    //     data: submit_data,
    //   })
    //     .then(() => {
    //       this.$iziToast.success({
    //         timeout: 2000,
    //         message: this.$t("editSuccess"),
    //         position: "bottomRight",
    //       });

    //       this.btnLoading = false;
    //       this.dialog = false;
    //     })
    //     .catch((err) => {
    //       this.btnLoading = false;
    //       this.$iziToast.error({
    //         timeout: 2000,
    //         message: err.response.data.message,
    //         position: "bottomRight",
    //       });
    //     });
    // },
  },

  watch: {
    loading(newVal) {
      this.btnLoading = newVal;
    },
    closeModal(newVal) {
      if (newVal) this.dialog = false;
    },
  },
};
</script>

<style></style>
